import i18next from 'i18next';

import { deleteSegment } from 'common/api/v1/segmentsLayout';
import { POLYGON_SEGMENT } from 'common/components/segment/constants';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    DELETE_SEGMENT_FAILURE,
    DELETE_SEGMENT_SUCCESS,
    DELETE_SEGMENT,
    FETCH_OFFER_PANELS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';
import * as selectors from '../selectors';

import updateSegments from './updateSegments';

export default (callback, id) => (dispatch, getState) => {
    const state = getState();
    const segments = selectors.getSegmentsData(state);

    dispatch(actions[DELETE_SEGMENT]());

    deleteSegment(id)
        .then(() => {
            dispatch(actions[DELETE_SEGMENT_SUCCESS]());
            const filteredSegments = segments.filter(
                (current) => current.id !== id,
            );
            dispatch(updateSegments(filteredSegments));
            showToast({ body: i18next.t('Segment has been removed') });

            const panels = filteredSegments
                .filter((segment) => segment.type === POLYGON_SEGMENT)
                .map((segment) => segment.panel);

            dispatch(
                actions[FETCH_OFFER_PANELS_SUCCESS]({
                    panels,
                }),
            );

            if (callback) callback(id);
        })
        .catch((error) => {
            dispatch(
                actions[DELETE_SEGMENT_FAILURE](error?.response?.data?.errors),
            );
            showReponseErrorsAsAlert(dispatch, error.response);
        });
};
